export default __webpack_public_path__ + "static/media/jolt-65-3.15884e87.jpg";